import { DASHBOARD_APIS_DATA } from "../types";

export interface IDashboardApisData {
  provincesForTDForm: any;
  adjustment_options: any;
  client_detail: any;
  default_setting: any;
  global_variable: any;
  rl1_summary: any;
  rl3_summary: any;
  rl16_summary: any;
  t3_summary: any;
  t4_summary: any;
  t4_summary_reduce_ei: any;
  t4a_summary: any;
  t5_summary: any;
  masked_status: boolean;
  general_settings: any;
}

const initialState: IDashboardApisData = {
  provincesForTDForm: {},
  adjustment_options: null,
  client_detail: null,
  default_setting: null,
  global_variable: null,
  rl1_summary: null,
  rl3_summary: null,
  rl16_summary: null,
  t3_summary: null,
  t4_summary: null,
  t4_summary_reduce_ei: null,
  t4a_summary: null,
  t5_summary: null,
  masked_status: true, //data is masked
  general_settings: null,
};

export const dashboardApisDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DASHBOARD_APIS_DATA.DASHBOARD_APIS_DATA_SET_SELECTED:
      return {
        ...state,
        ...action.payload,
      };
    case DASHBOARD_APIS_DATA.DASHBOARD_APIS_DATA_CLEAR_SELECTED:
      return {
        ...state,
        provincesForTDForm: initialState.provincesForTDForm,
        adjustment_options: initialState.adjustment_options,
        client_detail: initialState.client_detail,
        default_setting: initialState.default_setting,
        global_variable: initialState.global_variable,
        rl1_summary: initialState.rl1_summary,
        rl3_summary: initialState.rl3_summary,
        rl16_summary: initialState.rl16_summary,
        t3_summary: initialState.t3_summary,
        t4_summary: initialState.t4_summary,
        t4_summary_reduce_ei: initialState.t4_summary_reduce_ei,
        t4a_summary: initialState.t4a_summary,
        t5_summary: initialState.t5_summary,
        masked_status: initialState.masked_status,
        general_settings: initialState.general_settings,
      };
    default:
      return state;
  }
};
